module.exports = __webpack_public_path__ + "img/boat9.4ac50c5d.jpg";